// extracted by mini-css-extract-plugin
export default {"child-modal-espot__container-espot":"child-modal-espot__container-espot"};